import styled from 'styled-components';
import {
  H1,
  H2,
  H3,
  SectionParent,
} from '../../../components/StyledComponents';

import React from 'react';
import lottie, { AnimationItem } from 'lottie-web';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import deploy from '../../../assets/v2/DigitalSignage/deploy.svg';
import operation from '../../../assets/v2/DigitalSignage/operation.svg';
import remote from '../../../assets/v2/DigitalSignage/remotehealth.svg';
import hardware from '../../../assets/v2/DigitalSignage/hardware.svg';
import telemetry from '../../../assets/v2/DigitalSignage/telemetry.svg';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #f4f6fb;
  border-bottom: solid 1px #a5b2d3;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  background-size: contain;
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  margin-top: 2rem;
  background: #ffffff;
  border-radius: 4px;
  width: 82%;
  box-shadow: 0 3px 18px 0 rgba(72, 82, 108, 0.15);
  margin-bottom: 1rem;
  padding: 3rem;
  padding-right: 0;
  padding-bottom: 1rem;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 768px) {
    /* grid-template-columns: repeat(2, 1fr); */
    padding: 2rem;
    width: 100%;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 2;
  border-radius: 5px;
  max-width: 80%;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 2rem;
  }
`;
const GridItemBottom = styled.div`
  grid-column: span 3;
  justify-self: center;
  border-radius: 5px;
  max-width: 80%;
  @media (max-width: 1024px) {
    grid-column: span 2;
    justify-self: start !important;
    padding-left: 0 !important;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    justify-self: center !important;
    margin-bottom: 2rem;
  }
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #736e79;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;
const HeroTitle = styled(H1)`
  /* margin-left: 2.5rem; */
  padding-bottom: 1rem;
  color: #151828;
  text-align: center;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
`;
const StyledImg = styled(LazyLoadImage)`
  height: 46px;
`;
const TitlesContainer = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  min-height: 1em;
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: 1;
    margin-top: 0.5rem;
  }
`;
export default class DigitalSectionSix extends React.Component<any, any> {
  animation?: AnimationItem;
  interval1: any;
  interval2: any;
  isCMounted = true;

  constructor(props: any) {
    super(props);
    this.animation = undefined;

    this.state = {
      counter: 1,
      animationPaused: false,
      textArray: [
        {
          title: 'Efficiently Deploy',
          description:
            'No-touch enrollment and provisioning. Design once, deploy anywhere.',
        },
        {
          title: 'Operational Agility',
          description:
            'Agile configurations. Real-time updates. Continuous improvement.',
        },
        {
          title: 'Remote Diagnostics',
          description:
            'Monitor health and security. Receive actionable alerts.Take real-time action.',
        },
        {
          title: 'Hardware choice',
          description: 'Rich hardware options, OEM, SBC, Custom build ',
        },
        {
          title: 'Telemetry',
          description:
            'Remote Control. Detailed Logging. Remote Debugging Tools.',
        },
      ],
    };
  }

  //   scrollFunction = () => {
  //     // Get the header
  //     const header = document.getElementById('section-one-kiosk');

  //     if (header && this.isCMounted) {
  //       // Get the offset position of the navbar
  //       const containerTop = header!.offsetTop;
  //       // const containerBottom = header!.offsetTop + header!.clientHeight;
  //       const currentBottomPosition = window.pageYOffset + window.innerHeight;
  //       const currentTopPosition = window.pageYOffset;
  //       if (
  //         currentBottomPosition > containerTop &&
  //         currentTopPosition < containerTop
  //       ) {
  //         // lottie.play('animation-kiosk')
  //         const scrollPercent = (45 * currentTopPosition) / containerTop;
  //         const scrollRounded = Math.round(scrollPercent);
  //         this.animation!.goToAndStop(scrollRounded, true);
  //       } else {
  //         this.animation!.goToAndStop(45, true);
  //       }
  //     }
  //   };

  componentWillUnmount() {
    this.isCMounted = false;
    clearInterval(this.interval1);
    clearInterval(this.interval2);
  }
  async componentDidMount() {
    localStorage.setItem('prevPage', 'contact-us, test, tetrt');
    console.log(localStorage);
    this.isCMounted = true;
    this.handleAnimation();
    const animationData = await import(
      '../../lottieAnimations/Digital_Lifecycle.json'
    );
    // window.onscroll = this.scrollFunction;
    this.animation = lottie.loadAnimation({
      animationData,
      name: 'animation-kiosk',
      container: document.getElementById('lottie-animation-life')!,
      loop: true,
      renderer: 'canvas',
      autoplay: true,
    });

    // TODO Important @Rohan handle clearing the interval
    const perActionTime =
      (this.animation?.getDuration() * 1000) / this.state.textArray?.length;
    console.log('this.animation?.getDuration()', this.animation?.getDuration());
    console.log('perActionTime', perActionTime);
    this.interval1 = setInterval(this.handleText, 2 * perActionTime);
    this.interval2 = setTimeout(
      () => setInterval(this.handleAnimation, perActionTime),
      1850
    );
    console.log(this.interval1, this.interval2);
  }

  handleText = () => {
    this.setState((state: any) => ({
      counter: state.counter === 4 ? 0 : state.counter + 1,
    }));
  };
  handleAnimation = () => {
    if (this.state.animationPaused) {
      this.animation?.play();
    } else {
      this.animation?.pause();
    }
    this.setState({ animationPaused: !this.state.animationPaused });
  };
  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <HeroTitle>
            Full Stack End-to-End Answers <br />
            for the Digital Signage Lifecycle
          </HeroTitle>
          <GridContainer>
            <GridItem>
              <ImgWrapper>
                <StyledImg src={deploy} />
              </ImgWrapper>
              <TitlesContainer>
                <GridTitle>Efficiently Deploy</GridTitle>
              </TitlesContainer>
              <GridItemContent>
                No-touch enrollment and provisioning. Design once, deploy
                anywhere.
              </GridItemContent>
            </GridItem>
            <GridItem>
              <ImgWrapper>
                <StyledImg src={operation} />
              </ImgWrapper>
              <TitlesContainer>
                <GridTitle>Operational Agility</GridTitle>
              </TitlesContainer>
              <GridItemContent>
                Agile configurations. Real-time updates. Continuous improvement.
              </GridItemContent>
            </GridItem>
            <GridItem>
              {' '}
              <ImgWrapper>
                <StyledImg src={remote} />
              </ImgWrapper>
              <TitlesContainer>
                <GridTitle>Remote Diagnostics</GridTitle>
              </TitlesContainer>
              <GridItemContent>
                Monitor health and security. Receive actionable alerts. Take
                real-time action.
              </GridItemContent>
            </GridItem>
            <GridItemBottom>
              {' '}
              <ImgWrapper>
                <StyledImg src={hardware} />
              </ImgWrapper>
              <TitlesContainer>
                <GridTitle>Hardware Choice</GridTitle>
              </TitlesContainer>
              <GridItemContent>
                Rich hardware options. Validated <br />
                SBCs or custom OEM builds
              </GridItemContent>
            </GridItemBottom>
            <GridItemBottom
              style={{ justifySelf: 'start', paddingLeft: '2rem' }}
            >
              {' '}
              <ImgWrapper>
                <StyledImg src={telemetry} />
              </ImgWrapper>
              <TitlesContainer>
                <GridTitle>Telemetry</GridTitle>
              </TitlesContainer>
              <GridItemContent>
                Remote Control. Detailed Logging.
                <br /> Remote Debugging Tools.
              </GridItemContent>
            </GridItemBottom>
          </GridContainer>
        </SectionOne>
      </div>
    );
  }
}
